var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-text flex-col flex justify-center items-center"},[_c('LoadingSpinner',{staticClass:"w-8 h-8"}),_c('div',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t('loading'))+"... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }